import { LeasePacketSection } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { useLockedLeasePacketSection } from './hooks';

function LockedLeasePacket(props) {
  const clProps = useLockedLeasePacketSection(props);
  return <LeasePacketSection {...clProps} />;
}

export default LockedLeasePacket;
